document.addEventListener("DOMContentLoaded", function () {
  let proxyProductVariantId = "45816725733630"; // Gift wrap variant ID 
  let premiumWrapId = "47127985881342"; // Gift wrap premium ID

 
  function getGiftWrapVariantId(cartTotal) {
    if (cartTotal >= 20000) {
      //return "47127985881342";
      return "45816725733630";
    }
    return "45816725733630";
  }

  // Function to check if a specific variant is in the cart and update a checkbox
  function checkVariantInCart(checkbox, variantId) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let inCart = data.items.some((item) => item.id == variantId);
        checkbox.checked = !!inCart;
      })
      .catch((error) => console.error("Error checking cart:", error));
  }

  function simulateClickOnProductRemove(variantId) {
    const closeButton = document.querySelector(`[data-item-id="${variantId}"]`);
    if (closeButton) {
      closeButton.click();
    } else {
      // Fallback to direct change API
      removeVariantFromCart(variantId);
    }
  }

 
  function addVariantToCart(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then((response) => response.json())
      .then((data) => {
        refreshCart();
      })
      .catch((error) => console.error("Error:", error));
  }

  // Function to fetch product details by handle
  function fetchProductByHandle(handle) {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .catch((error) => console.error("Error fetching product:", error));
  }

  // Function to remove a specific variant from the cart
  function removeVariantFromCart(variantId) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
      .then((response) => response.json())
      .then((data) => {
        // no-op
      })
      .catch((error) => console.error("Error:", error));
  }

  // Function to uncheck and disable the gift wrap checkbox
  function disableGiftWrap() {
    let checkbox = document.querySelector("#checkbox_giftwrap");
    if (checkbox) {
      checkbox.checked = false; // Uncheck the checkbox
      checkbox.disabled = true; // Disable the checkbox
    }
  }

  // Function to refresh the cart
  function refreshCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        // console.log("Cart updated:", data);
        let qtyInput = document.querySelector("[data-item-qty]");

        if (!qtyInput) return;

        qtyInput.dispatchEvent(new Event("change"));
      })
      .catch((error) => console.error("Error refreshing cart:", error));
  }

  // Function to handle cart updates after AJAX re-renders
  function handleCartUpdates() {
    // Observe changes to the cart form wrapper
    let cartPage = document.querySelector(".cart-page");

    if (!cartPage) return;

    let cartFormWrapper = cartPage.querySelector(".ajax-cart__form-wrapper");

    if (cartFormWrapper) {
      const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach(function (node) {
              if (
                node.nodeType === 1 &&
                node.classList.contains("ajax-cart__cart-form")
              ) {
                const freeCheckbox = node.querySelector("#checkbox_giftwrap");
                const premiumCheckbox = node.querySelector("#checkbox_giftwrap_premium");

                if (freeCheckbox) {
                  checkVariantInCart(freeCheckbox, proxyProductVariantId);
                  freeCheckbox.addEventListener("change", function (event) {
                    if (event.target.checked) {
                      // ensure premium is not selected
                      if (premiumCheckbox) {
                        premiumCheckbox.checked = false;
                      }
                      // Only remove premium if total is below threshold
                      fetch("/cart.js")
                        .then((r) => r.json())
                        .then((cartData) => {
                          if (cartData.total_price < 20000) {
                            simulateClickOnProductRemove(premiumWrapId);
                          }
                        })
                        .catch(() => {});
                      addVariantToCart(proxyProductVariantId);
                    } else {
                      simulateClickOnProductRemove(proxyProductVariantId);
                    }
                  });
                }

                if (premiumCheckbox) {
                  checkVariantInCart(premiumCheckbox, premiumWrapId);
                  premiumCheckbox.addEventListener("change", function (event) {
                    if (event.target.checked) {
                      // ensure free is not selected
                      if (freeCheckbox) {
                        freeCheckbox.checked = false;
                      }
                      simulateClickOnProductRemove(proxyProductVariantId);
                      addVariantToCart(premiumWrapId);
                    } else {
                      simulateClickOnProductRemove(premiumWrapId);
                    }
                  });
                }

                // Sync visibility based on cart total
                updateUIFromCart();
              }
            });

            handleCartChange();
          }
        });
      });

      // Start observing the cartFormWrapper for childList changes
      observer.observe(cartFormWrapper, { childList: true });
    } else {
      console.log("cartFormWrapper not found.");
    }
  }

  // Toggle premium wrapper visibility and sync both checkboxes with cart state
  function updateUIFromCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const cartTotal = data.total_price;
        const freeCheckbox = document.querySelector("#checkbox_giftwrap");
        const premiumCheckbox = document.querySelector("#checkbox_giftwrap_premium");

        if (freeCheckbox) {
          freeCheckbox.checked = data.items.some((i) => i.id == proxyProductVariantId);
        }
        if (premiumCheckbox) {
          premiumCheckbox.checked = data.items.some((i) => i.id == premiumWrapId);
          const wrapper = premiumCheckbox.closest(".giftwrap-wrapper");
          if (wrapper) {
            if (cartTotal < 20000) {
              wrapper.style.display = "";
              premiumCheckbox.disabled = false;
            } else {
              // When total >= 200, hide but do not remove the premium item
              wrapper.style.display = "none";
            }
          }
        }
      })
      .catch((error) => console.error("Error updating gift wrap UI:", error));
  }

  // Callback function to handle cart updates, check for 'sale' items, and remove them
  function handleCartChange() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        let promises = data.items.map((item) =>
          fetchProductByHandle(item.handle).then((product) => {
            // Buscar la variante específica agregada al carrito
            const variant = product.variants.find(v => v.id == item.id);
            return variant;
          })
        );

        Promise.all(promises).then((variants) => {
          const hasSaleVariant = variants.some(
            (variant) =>
              variant && variant.compare_at_price > variant.price
          );
          if (hasSaleVariant) {
            simulateClickOnProductRemove(proxyProductVariantId);
            disableGiftWrap();
          }
          // Also keep premium visibility/status in sync after any cart change
          updateUIFromCart();
        });
      })
      .catch((error) =>
        console.error("Error checking cart for 'sale' items:", error)
      );
  }

  // GET cart event listener
  document.addEventListener("cart::get", function (event) {
    handleCartChange();
    updateUIFromCart();
  });

  // Call this function to set up the observer and handle updates
  handleCartUpdates();
  updateUIFromCart();
});

// // CHANGE cart event listener
// document.addEventListener("cart::change", function (event) {
//   console.log("change cart", event.detail.cartItem);
// });

// // CHANGE cart event listener
// document.addEventListener("cart::update", function (event) {
//   console.log("update cart", event.detail.body);
// });
